import i18n, { type Resource, use } from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';

const resources: Resource = {
    en: {
        default: en,
        translation: en,
    },
};

use(initReactI18next).init({
    resources,
    lng: 'en',
    debug: true,

    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
